import { useState, useContext } from 'react'
import { ExamContext } from 'containers/Examination/ExaminationContext'
import { Modal, Fade, Backdrop, Grid, Paper, Box, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem,
  Collapse, IconButton } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { getUserClassrooms, updateExamination } from 'containers/Examination/ExaminationService'
import dayjs from 'dayjs'
import TimerSettings from './TimerSettings'

import './Settings.css'
import { useEffect } from 'react'

const Settings = () => {
  const examEditor = useContext(ExamContext)
  const [openSettingsModal, setOpenSettingsModal] = useState(false)

  const openSettings = (e) => {
    e.preventDefault()
    setOpenSettingsModal(true)
  }

  const closeSettings = () => {
    setOpenSettingsModal(false)
  }

  const [classrooms, setClassrooms] = useState({})
  const getClassrooms = async () => {
    let classrooms = await getUserClassrooms()
    setClassrooms(classrooms)
  }

  const [showAlert, setShowAlert] = useState(false)

  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [attempts, setAttempts] = useState(1)
  const [classroom, setClassroom] = useState(examEditor.exam.class_code)

  const [startDateHelperText, setStartDateHelperText] = useState('')
  const [startDateHasError, setStartDateHasError] = useState(false)

  const [endDateHelperText, setEndDateHelperText] = useState('')
  const [endDateHasError, setEndDateHasError] = useState(false)

  const [attempHelperText, setAttemptHelperText] = useState('')
  const [attempHasError, setAttemptHasError] = useState('')

  const [status, setStatus] = useState('draft')

  const [updating, setUpdating] = useState(false)

  const [timerSettings, setTimerSettings] = useState({})

  const updateExamDetails = async () => {
    let hasError = false

    setStartDateHelperText("")
    setStartDateHasError(false)
    if (startDate === "") {
      setStartDateHelperText('This field is required')
      setStartDateHasError(true)
      hasError = true
    }

    setEndDateHelperText('')
    setEndDateHasError(false)
    if (endDate === "") {
      setEndDateHelperText('This field is required')
      setEndDateHasError(true)
      hasError = true
    }

    setAttemptHelperText('')
    setAttemptHasError(false)
    if (attempts === "") {
      setAttemptHelperText('This field is requierd')
      setAttemptHasError(true)
      hasError = true
    }

    if (parseInt(attempts) <= 0) {
      setAttemptHelperText('This field must have value of at least 1')
      setAttemptHasError(true)
      hasError = true
    }

    if (timerSettings.displayFields !== undefined && timerSettings.displayFields === true) {
      // Validate the fields here

    }

    if (hasError) return

    setUpdating(true)

    await updateExamination(examEditor.exam.id, {
      start: startDate,
      end: endDate,
      max_attempt: attempts,
      class_code: classroom,
      enable_timer: timerSettings.displayFields,
      questions_per_screen: timerSettings.questionPerScreen,
      seconds_per_screen: timerSettings.secondsPerScreen,
      status
    })

    setShowAlert(true)
    setUpdating(false)
  }

  useEffect(() => {
    getClassrooms()
  }, [])

  useEffect(() => {
    setClassroom(examEditor.exam.class_code)
    setStartDate(dayjs(examEditor.exam.start).format('YYYY-MM-DD HH:mm'))
    setEndDate(dayjs(examEditor.exam.end).format('YYYY-MM-DD HH:mm'))
    setAttempts(examEditor.exam.max_attempt)
    setStatus(examEditor.exam.status ? 'published' : 'draft')
  }, [examEditor])

  return (
    <>
      <a
        href="/"
        onClick={openSettings}
      >
        <i className="fa fa-cogs"></i> Settings
      </a>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openSettingsModal}
        onClose={closeSettings}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openSettingsModal}>
          <Grid container item md={8} lg={6} style={{margin: '0 auto', marginTop: '30px'}}>
            <Paper style={{width: '100%', padding: '20px'}}>
              <Grid container direction="column">

                <Grid className="exam-details-container" item>
                  <button className="close-modal" onClick={closeSettings}>
                    <i className="fa fa-times"></i>
                  </button>
                </Grid>

                <Grid item style={{marginBottom: '10px'}}>
                  <Typography variant="h6">Examination Settings</Typography>
                </Grid>

                <Collapse in={showAlert} style={{marginBottom: '20px'}}>
                  <Alert
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setShowAlert(false);
                        }}
                      >
                        <i className="fa fa-times-circle"></i>
                      </IconButton>
                    }
                  >
                    Exam details updated
                  </Alert>
                </Collapse>

                <Grid item>
                  <Grid container>
                    <Box flexGrow={1} paddingRight={1}>
                      <TextField
                        label="Start"
                        type="datetime-local"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        helperText={startDateHelperText}
                        fullWidth
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </Box>
                    <Box flexGrow={1} paddingLeft={1}>
                      <TextField
                        label="End"
                        type="datetime-local"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        helperText={endDateHelperText}
                        fullWidth
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </Box>
                  </Grid>
                </Grid>

                <Grid item>
                  <TextField
                    id="attemps"
                    label="Max Attemp"
                    helperText={attempHelperText}
                    value={attempts}
                    onChange={(e) => setAttempts(e.target.value)}
                    fullWidth
                  />
                </Grid>

                <Grid item>
                  <FormControl fullWidth>
                    <InputLabel id="class">Classroom</InputLabel>
                    <Select
                      labelId="class"
                      value={classroom}
                      onChange={(e) => setClassroom(e.target.value)}
                    >
                      {classrooms.length > 0 && classrooms.map((c) => (
                        <MenuItem value={c.class_code} key={c.class_code}>{`${c.room} - ${c.name}`}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item>
                  <TimerSettings examDetails={examEditor} updateTimerSettings={setTimerSettings} />
                </Grid>

                <Grid item>
                  <FormControl fullWidth>
                    <InputLabel id="class">Status</InputLabel>
                    <Select
                      labelId="class"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <MenuItem value="draft">Draft</MenuItem>
                      <MenuItem value="published">Published</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item container justifyContent="flex-end" spacing={2} style={{marginTop: '20px'}}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={updateExamDetails}
                  >
                    {!updating && <><i className="fa fa-save"></i>&nbsp;Update Settings</>}
                    {updating && <><i className="fa fa-spinner fa-spin"></i>&nbsp;Updating settings ...</>}
                  </Button>
                </Grid>

              </Grid>
            </Paper>
          </Grid>
        </Fade>
      </Modal>
    </>
  )
}

export default Settings